module.exports = __webpack_public_path__ + "static/media/DC_F_Embroidery_Bicocca_IndBlue_White.ee0a484d.png";